import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

const controlStyles = {
    borderRadius: '1px solid black',
    color: 'white',
};

const ControlComponent = (props) => (
    <div style={controlStyles}>
        <components.Control {...props} />
    </div>
);

const CategoryDropdown = ({ getCategory, modalInfo }) => {
    const [categorySelect, setCategorySelect] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        const getCategories = async () => {
            const categoryFromServer = await fetchCategory();
            setCategorySelect(categoryFromServer);
        };

        if (modalInfo) {
            if(!modalInfo.categoryID.includes(0)){
                const [categoryIDList, categoryNameList] = [
                    modalInfo.categoryID.split(','),
                    modalInfo.categoryName.split(','),
                ];
                const category = categoryIDList.map((node, index) => ({
                    value: node,
                    label: categoryNameList[index]
                }));
                setSelectedOption(category)
            }
        }

        getCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalInfo]);

    // Fetch Categories
    const fetchCategory = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/grievance/getfactoryAndCategorylist'
        );
        const data = await res.json();

        return data.grievanceCategoryList;
    };

    const options = categorySelect.map((category, index) => {
        return {
            value: category.id,
            label: category.name
        }
    })

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);


        if (selectedOption) {
            getCategory(
                Array.isArray(selectedOption)
                ? selectedOption.map((item) => item.value)
                : null
            )
        }

    };

    return (
        <Select
            placeholder={'Select a category...'}
            components={{ Control: ControlComponent }}
            value={selectedOption}
            onChange={handleChange}
            options={options}
            isMulti
            isClearable
        />
    );
};

export default CategoryDropdown;
